import { useContext } from 'react'
import { DialogOptions } from 'components/common/Dialog'
import { Context } from './context'

type PartialOptions = Omit<DialogOptions, 'variant'>

const useConfirmation = () => {
  const openConfirmationModal = useContext(Context)

  const alert = (options: PartialOptions) => openConfirmationModal({ ...options, variant: 'alert' })

  const confirm = (options: PartialOptions) =>
    new Promise<boolean>(resolve => {
      openConfirmationModal({
        ...options,
        variant: 'confirm',
        catchOnCancel: true,
      })
        .then(() => resolve(true))
        .catch(() => resolve(false))
    })

  return {
    alert,
    confirm,
  }
}

export default useConfirmation
